export const getSubPath = (pathname) => {
    console.log('i18s.js path name' + pathname);
    if (process.env.NODE_ENV === 'development') {
        return '';
    } else {
        const webPortalIndex = pathname.indexOf('bsmPortal');
        let subPath = webPortalIndex > -1 ? pathname.substr(0, webPortalIndex + 9) : pathname;
        subPath = subPath.replace('index.html', '');
        // subPath = !subPath.startsWith('/') ? subPath : subPath.substr(1);
        subPath = !subPath.endsWith('/') ? subPath : subPath.substr(0, subPath.length - 1);
        console.log('i18s.js sub path name' + subPath);
        return subPath;
    }
};
